/**
 * EventTitleSection
 *
 * Large title input at the top of the event form.
 * Google Calendar style with underline input.
 */

import { Spacing } from '@/constants/spacing';
import { Colors } from '@/constants/theme';
import { getHeadingFont } from '@/constants/typography';
import { ReactNode } from 'react';
import { StyleSheet, TextInput, View } from 'react-native';

type EventTitleSectionProps = {
  value: string;
  onChange: (value: string) => void;
  palette: typeof Colors.light;
  leadingSlot?: ReactNode;
};

export function EventTitleSection({ value, onChange, palette, leadingSlot }: EventTitleSectionProps) {
  return (
    <View style={styles.container}>
      {leadingSlot && <View style={styles.leadingSlot}>{leadingSlot}</View>}
      <TextInput
        style={[
          styles.input,
          {
            color: palette.text,
            borderBottomColor: palette.border,
            fontFamily: getHeadingFont(),
          },
        ]}
        value={value}
        onChangeText={onChange}
        placeholder="Add title"
        placeholderTextColor={palette.textMuted}
        multiline
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.md,
  },
  leadingSlot: {
    width: 40,
    alignItems: 'center',
  },
  input: {
    flex: 1,
    fontSize: 18,
    fontWeight: '500',
    paddingVertical: Spacing.sm,
  },
});
